/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import React from 'react';
import Modal from '@material-ui/core/Modal';
import { Box, makeStyles, Typography } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import Button from '../Button';

const useStyles = makeStyles(theme => ({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: '9999 !important',
  },
  content: {
    display: 'flex',
    position: 'relative',
    width: '75%',
    height: '75%',
    padding: '0 2rem',
    flexDirection: 'column',
    border: 'none',
    borderRadius: '1rem',
    outline: 'none',
    boxShadow: theme.shadows[5],
    backgroundColor: theme.palette.background.paper,
  },
  header: {
    display: 'inline-flex',
    alignItems: 'center',
    height: '5rem',
  },
  title: {
    flex: 'auto',
  },
  body: {
    height: 'calc(100% - 5rem - 5rem)',
  },
  footer: {
    display: 'inline-flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    height: '5rem',
  },
}));

export default function SimpleModal({ children, isOpen, onClose, title, subtitle }) {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <Modal open={isOpen} onClose={onClose} className={classes.modal}>
      <div className={classes.content} role="dialog" aria-modal="true">
        <div className={classes.header}>
          <Box className={classes.title}>
            <Typography variant="h5" component="span">
              {title}
            </Typography>
            <Typography variant="subtitle1" component="span" gutterBottom>
              {subtitle}
            </Typography>
          </Box>
        </div>

        <div className={classes.body}>{children}</div>

        <Box className={classes.footer}>
          <Button id="closeModal" color="primary" className={classes.actionButton} onClick={onClose}>
            {t('actions.close')}
          </Button>
        </Box>
      </div>
    </Modal>
  );
}
